module.exports = __webpack_public_path__ + "static/media/instagram_full.08e793a1cff64a71ddf38ac809a9ff9d.svg";